import { AuthProvider, useAuth } from './lib/auth.js';
import { useRoute } from './lib/router.js';
import { Nav } from './components/Nav.js';
import { Login } from './views/Login.js';
import { Overview } from './views/Overview.js';
import { Feedback } from './views/Feedback.js';
import { Roadmap } from './views/Roadmap.js';
import { Changelog } from './views/Changelog.js';
import { Players } from './views/Players.js';
import { Rooms } from './views/Rooms.js';
import { Telemetry } from './views/Telemetry.js';
import { Progression } from './views/Progression.js';
import { Choir } from './views/Choir.js';
import { Flags } from './views/Flags.js';

function Shell() {
  const { player } = useAuth();
  const route = useRoute();

  if (!player) return <Login />;

  let view;
  switch (route) {
    case 'feedback':
      view = <Feedback />;
      break;
    case 'roadmap':
      view = <Roadmap />;
      break;
    case 'changelog':
      view = <Changelog />;
      break;
    case 'players':
      view = <Players />;
      break;
    case 'rooms':
      view = <Rooms />;
      break;
    case 'telemetry':
      view = <Telemetry />;
      break;
    case 'progression':
      view = <Progression />;
      break;
    case 'choir':
      view = <Choir />;
      break;
    case 'flags':
      view = <Flags />;
      break;
    case 'login':
    case 'overview':
    default:
      view = <Overview />;
  }

  return (
    <div class="shell">
      <Nav current={route === 'login' ? 'overview' : route} />
      <main class="main">{view}</main>
    </div>
  );
}

export function App() {
  return (
    <AuthProvider>
      <Shell />
    </AuthProvider>
  );
}
